"use strict";
/* eslint-disable import/prefer-default-export */
Object.defineProperty(exports, "__esModule", { value: true });
exports.parsePayloadChallenge = void 0;
var conversions_1 = require("../../../../utils/conversions");
var parsePayloadChallenge = function (dataView) {
    return {
        // status: dataView?.getUint32(0),
        payloadChallengeResponse: (0, conversions_1.buf2hex)(dataView.buffer),
    };
};
exports.parsePayloadChallenge = parsePayloadChallenge;
